<template>
  <div id="standalone-places-searchbox-container" class="container">
    <div ref="domNode" class="places-searchbox" :class="{ 'is-smt': isSmt }">
      <label for="search-field" class="label">
        <span class="accessibility">{{
          useMicroCopy("servicelocator.location.label")
        }}</span>
        <SvgIcon :name="!isSmt ? 'func_search' : 'func_locator'" class="icon-search" />
      </label>
      <input
        id="search-field"
        ref="buttonNode"
        v-model="query"
        tabindex="0"
        type="text"
        :placeholder="useMicroCopy('servicelocator.placeholder')"
        name="search-field"
        class="search-field"
        aria-haspopup="true"
        aria-controls="menu2"
      />
      <SimpleButton
        class="search-button"
        solid
        @click="query?.length ? handleSearch() : ''"
        v-if="!isSmt"
      >
        <span class="text">{{
          useMicroCopy("servicelocator.searchcta.label")
        }}</span>
        <SvgIcon name="func_search" class="icon-search" />
      </SimpleButton>
    </div>
    <div class="filters" v-if="!isSmt">
      <div
        v-for="filter in allowedFacilityTypeGroupKeysList"
        :key="filter"
        class="filter"
      >
        <FormCheckbox
          v-model="filter.isIncluded"
          :name="filter.name"
          :label="
            useMicroCopy(
              `servicelocator.searchengine.label.${filter.name?.replace(
                '-',
                ''
              )}`
            )
          "
          @change="
            trackingStore.updateKeywords(query);
            updateFilters($event, filter.name);
          "
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTrackingStore } from "@/stores/tracking";

const config = useRuntimeConfig();
const trackingStore = useTrackingStore();

const isSmt = computed(() => props.location === "smt");

const props = defineProps({
  location: {
    type: String,
    default: "",
  },
  includeFacilityTypeGroupKey: {
    type: [String, Array],
    required: false,
    default: "",
  },
});

const allowedFacilityTypeGroupKeysList = await GetFacilityTypeGroupKeys(
  props.includeFacilityTypeGroupKey,
  null
);

const updateFilters = (event, name) => {
  const filter = allowedFacilityTypeGroupKeysList?.find(
    (item) => item.name === name
  );
  filter.isIncluded = event.target.checked;
};

const query = ref("");

const handleSearch = async (forceFilters = null) => {
  const locator = await useCustomAsyncStoryblok("", {
    version: config.public["storyblokVersion"],
    content_type: "page-locator",
    starts_with: config.public["storyblokCountryPrefix"],
  })
    .then((response) => {
      if (response.value.stories.length > 0) {
        return strippedURL(response.value.stories[0].full_slug);
      }
      return "/";
    })
    .catch((error) => {
      console.log(error); // eslint-disable-line
    });

  window.location.href = locator;
};

defineExpose({ handleSearch, query })
</script>

<style lang="scss" scoped>
.places-searchbox {
  z-index: 1;
  padding: 0.25rem 0.25rem 0.25rem 1.12rem;
  @include pair-7;
  border-radius: $radius-m;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  height: 3.75rem;

  @include for-tablet-landscape-up {
    padding-left: 1.5rem;
    border-radius: $radius-l;
    height: 5rem;
  }

  &.is-smt {
    background-color: var(--solid-05);

    @include for-tablet-landscape-up {
      height: 64px;
    }

    .search-field {
      background-color: transparent;
      outline: none;
      font-size: 1rem;
    }
    svg {
      opacity: 0.3;
    }
    ul {
      width: 100%;
    }
  }

  .label {
    display: block;
    @include size-2xs;
    .icon-search {
      width: 1.5rem;
      height: auto;
      margin-top: 0.2rem;
      @include for-phone-only {
        display: none;
      }
    }
  }

  .search-field {
    appearance: none;
    border: none;
    margin: 0;
    display: block;
    padding: 0;
    height: 100%;
    width: 100%;
    @include size-m;

    @include for-tablet-landscape-up {
      @include size-s;
    }
  }
}


:deep(.simple-button) {
  color: var(--solid-07) !important;
  border-radius: $radius-m !important;
  height: 100%;
  @include for-tablet-landscape-up {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }
  .icon-search {
    width: 1.25rem !important;
    height: auto !important;

    path {
      fill: none !important;
    }
  }
}

.filters {
  display: inline-flex;
  gap: 0.75rem 1.25rem;
  flex-wrap: wrap;
  padding-top: 1.5rem;
  &.hidden {
    display: none;
  }
}

.filter {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;

  @include for-tablet-portrait-up {
    width: auto;
  }
}

.search-button {
  .text {
    display: none;
  }
  @include for-tablet-portrait-up {
    .text {
      display: inline-block;
    }
    .icon-search {
      display: none;
    }
  }
}

.checkbox :deep(input[type="checkbox"]) {
  @include for-desktop-down {
    width: 1.25rem !important;
    height: 1.25rem !important;
  }
}
</style>
